// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import '../src/scss/element-variables.scss'
import router from './router'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)


Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  ElementUI,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js